/* BABYGO identity (2026-09-16): one remembered email shared by every capture point on the site.
   Sources that SET it: wishlist sign-in, Follow Your Bump, the get-notified form, a Shopify customer login.
   Everything that asks for an email READS it and pre-fills with a "Using <email> · Change" note — screens
   are never skipped, the typing is. Klaviyo is told who the visitor is (identify) so its own forms — the 10%
   popup and back-in-stock — pre-fill too. Per browser; nothing here is sent anywhere except to Klaviyo. */
(function (w, d) {
  'use strict';
  var KEY = 'babygo_email';
  function read() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function get() { var r = read(); return (r && r.email) || ''; }
  function identify(email) {
    try { w.klaviyo = w.klaviyo || []; w.klaviyo.push(['identify', { $email: email }]); } catch (e) {}
  }
  function set(email, source) {
    email = String(email || '').trim().toLowerCase();
    if (!/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(email)) return false;
    var prev = get();
    try { localStorage.setItem(KEY, JSON.stringify({ email: email, source: source || 'unknown', ts: Date.now() })); } catch (e) {}
    identify(email);
    if (prev !== email) d.dispatchEvent(new CustomEvent('babygo:identity', { detail: { email: email, source: source } }));
    return true;
  }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }
  /* Pre-fill an email input with the known address and show the "Using … · Change" note beneath it.
     Returns true when it did. `Change` empties the field for a different address. */
  function decorate(input, opts) {
    opts = opts || {};
    if (!input) return false;
    var email = get();
    var note = input.parentNode.querySelector('.bg-known[data-for="' + (input.id || '') + '"]');
    if (!email) { if (note) note.remove(); input.classList.remove('bg-known-input'); return false; }
    if (input.value && input.value.trim().toLowerCase() !== email) return false; /* they typed something else — leave it */
    input.value = email;
    input.classList.add('bg-known-input');
    if (!note) {
      note = d.createElement('div'); note.className = 'bg-known'; note.setAttribute('data-for', input.id || '');
      note.innerHTML = '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.5l4 4L16 6"/></svg><span>Using <b></b></span><button type="button" class="bg-known__change">Change</button>';
      input.insertAdjacentElement('afterend', note);
      note.querySelector('.bg-known__change').addEventListener('click', function () {
        input.value = ''; input.classList.remove('bg-known-input'); note.remove(); input.focus();
        if (opts.onChange) opts.onChange();
      });
    }
    note.querySelector('b').textContent = email;
    if (opts.onKnown) opts.onKnown(email);
    return true;
  }
  w.BABYGO_ID = { get: get, set: set, clear: clear, decorate: decorate, identify: identify };

  /* ---- seed from whatever already knows the visitor ---- */
  if (!get()) {
    var seed = '';
    var m = d.querySelector('meta[name="babygo:customer-email"]'); if (m && m.content) seed = m.content;        /* Shopify account */
    try { if (!seed) seed = localStorage.getItem('babygo_wishlist_user') || ''; } catch (e) {}                    /* wishlist sign-in */
    try { if (!seed) seed = sessionStorage.getItem('fyb_email') || ''; } catch (e) {}                             /* Follow Your Bump */
    if (seed) set(seed, 'seed');
  } else {
    identify(get());
  }
  /* a Shopify login on this page load always wins */
  var cm = d.querySelector('meta[name="babygo:customer-email"]');
  if (cm && cm.content && cm.content.toLowerCase() !== get()) set(cm.content, 'shopify');

  /* generic: any theme signup form (e.g. the get-notified page) gets pre-filled */
  d.addEventListener('DOMContentLoaded', function () {
    d.querySelectorAll('form[data-klaviyo-signup] input[type="email"], form#bf-email-signup input[type="email"]').forEach(function (i) { decorate(i); });
  });
  /* testing: ?identity=reset forgets the shared email */
  try { if (/[?&]identity=reset\b/.test(location.search)) clear(); } catch (e) {}
})(window, document);
